import {Component, Input, OnInit, NgModule, ViewEncapsulation, Injector} from '@angular/core';

import {StringToStringMap} from "../../../../interfaces/string-string-map.interface";
import {CacheService} from "../../../../../services/sys/cache.service";
import {QueryCategory} from "../../../../../services/model/queryCategory";
import {StaticsService} from "../../../../../services/sys/statics.service";
import {Observable, Subject, Subscription} from "rxjs";
import {ApplicationService} from "../../../../../services/domain/application.service";
import {EfastFilterBaseComponent} from "../efast-filter-base.component";
import {FilterValue} from "../../../../../services/model/filterValue";



@Component({
    selector: 'efast-filter',
    templateUrl: 'efast-filter.component.html',
    styleUrls: ['efast-filter.component.css'],
    standalone: false
})

export class EfastFilterComponent extends EfastFilterBaseComponent implements OnInit {

    @Input() events: Observable<void>;
    @Input() isFilterShown: boolean = true;

    private fieldLabels: StringToStringMap<string> = {};
    private count: string;
    protected applicationService: ApplicationService;
/**
    constructor(private cacheService: CacheService,
                private staticsService: StaticsService,
                injector: Injector) {
        this.applicationService = injector.get(ApplicationService);
    }
 **/
    constructor(protected injector: Injector) {
        super(injector);
    }
    ngOnInit() {
        this.fieldLabels['title'] = this.cacheService.getLabelFromResource('FILTER:FILTERTitle');
        this.fieldLabels['latest'] = this.cacheService.getLabelFromResource('FILTER:FILTERLatestPerYear');

        this.eventsSubscription = this.events.subscribe(() => this.searchChangeEvent());
        this.searchChangeEvent();
    }
    //extended
    searchChangeEvent() {
        if (this.applicationService.getAfsForm() != undefined) {
            if (this.applicationService.getAfsForm().hits != undefined) {
                this.count = this.applicationService.getAfsForm().hits.found.toString();
            }
        }
        super.searchChangeEvent();
    }

    //extended
    protected rowClick(filterValue: FilterValue) {
        //alert("not ready");
      //  super.rowClick(filterValue);
        //this.queryManagerService.addQueryValueNoSearch(this.staticsService.getCategoryType().PLAN_YEAR, this.queryValue, true)
    }

    ngOnDestroy() {
        this.eventsSubscription.unsubscribe();
    }
}